import httpClient from "./httpClient";

//Login Function
export const login = async (payload) => {
    const response = await httpClient.post("/login", payload);
    return response.data;
};

// Logout Function
export const logout = async () => {
    const response = await httpClient.post("/logout");
    localStorage.clear();
    return response.data;
};

// Update Password Function
export const updatePassword = async (payload) => {
    const response = await httpClient.post("/update-password", payload);
    return response.data;
};

// GET Profile Function
export const getProfile = async () => {
    const response = await httpClient.get("/profileindex");
    return response.data;
};

//Update Profile Function
export const updateProfile = async (payload) => {
    const response = await httpClient.post("/profileupdate", payload,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
    return response.data;
};

// Send Reset Password Link
export const forgotPassword = async (payload) => {
    const response = await httpClient.post("/send_reset_password_link", payload);
    return response.data;
};

// Reset Password
export const resetPassword = async (payload) => {
    const response = await httpClient.post("/reset_passchange", payload);
    return response.data;
};